import { useMatching } from "./MatchingProvider";
import ConfirmDialog from "./ConfirmDialog";
import { useGlobalToast } from "components/GlobalToastProvider";

export default function RefreshDialog({ userId, isOpen, handleClose }) {
  const { showToast } = useGlobalToast();
  const { refreshAppointments, setGeneratedSchedules, setIsRefreshingProposed } = useMatching();

  const initiateRefresh = () => {
    refreshAppointments(
      { userId },
      {
        onSuccess: () => {
          console.log("Refresh initiated");
          handleClose();
          setGeneratedSchedules([]);
          setIsRefreshingProposed(true);
          showToast({ message: "Initiated new matching run", errorState: false });
        },
        onError: () => {
          handleClose();
          showToast({
            message: "Error initiating matching run",
            errorState: true,
          });
        },
      }
    );
  };
  return (
    <ConfirmDialog
      open={isOpen}
      handleClose={handleClose}
      onConfirm={() => initiateRefresh()}
      title="Refresh matching results?"
      message="This will initiate a new run of the matching job. The matching page will not be usable by you or any other user until the new run completes. This could take up to an hour."
      confirmText="Refresh"
    />
  );
}
